import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ObjectTagValuesDefaultOptions } from "../../services/object-tag-values-data-service/ConfigurationModels";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectTagValuesConfigurationDefaultOptionsParameters = {
    groupID: number,
    objectType?: eLynxObjectTypeEnum,
    objectID?: number,
    configurationID: number
} & BaseUseQueryParameters<ObjectTagValuesDefaultOptions>;

export function useObjectTagValuesConfigurationDefaultOptions({
    groupID,
    objectType,
    objectID,
    configurationID,
    enabled,
    onError,
    onSuccess
}: UseObjectTagValuesConfigurationDefaultOptionsParameters
) {
    return useQuery<ObjectTagValuesDefaultOptions | undefined, RestError>(
        keys.configurationDefaultOptions(groupID, configurationID),
        ({ signal }) => {
            if (configurationID) {
                return ObjectTagValuesDataService.getDefaultOptions(
                    groupID,
                    configurationID,
                    objectType,
                    objectID,
                    signal
                );
            }
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}